<common-card>
  <common-card-header>
    <h3>{{'modules.mission.mission_form.delayed_dialog.title' | translate}}</h3>
  </common-card-header>
  <common-card-body>
    <div class="row" [formGroup]="form">
      <div class="col-12">
        <div class="form-group">
          <label class="label required">
            {{'modules.mission.mission_form.delayed_dialog.reason' |translate}}
          </label>
          <nb-select formControlName="delayedReason" fullWidth>
            <nb-option *ngFor="let type of types"
                       [value]="type.value">
              {{type.name}}
            </nb-option>
          </nb-select>
          <slnk-shared-input-validator>
            <slnk-shared-input-validator-item
              [validationFormControl]="form.controls['delayedReason']"
              [validation]="'required'">
            </slnk-shared-input-validator-item>
          </slnk-shared-input-validator>
        </div>
      </div>
      <div class="col-12" *ngIf="showValetField()">
        <div class="form-group">
          <label class="label required">
            {{'modules.mission.mission_form.delayed_dialog.valet' | translate}}
          </label>
          <pv-common-autocomplete
            formControlName="valet"
            [selectItems]="availableValets">
          </pv-common-autocomplete>
          <slnk-shared-input-validator>
            <slnk-shared-input-validator-item
              [validationFormControl]="form.controls['valet']"
              [validation]="'required'">
            </slnk-shared-input-validator-item>
          </slnk-shared-input-validator>
        </div>
      </div>
      <div class="col-12">
        <label class="label">
          {{'modules.mission.mission_form.delayed_dialog.note' |translate}}
        </label>
        <textarea nbInput formControlName="note" fullWidth></textarea>
      </div>
      <div class="col-12 d-flex align-items-center mt-3">
        <nb-checkbox formControlName="doNotSendDelayMail">
        </nb-checkbox>
        <label class="label ml-2">
          {{'modules.mission.mission_form.delayed_dialog.do_not_send_delay_mail' |translate}}
        </label>
      </div>
    </div>
  </common-card-body>
  <common-card-footer>
    <div class="row">
      <div class="col-12 text-right">
        <button nbButton
                status="primary"
                [disabled]="!form.valid"
                (click)="submit()">
          {{'global.button.submit' | translate}}
        </button>
      </div>
    </div>
  </common-card-footer>
</common-card>
